import React, { useEffect, useState, useCallback } from "react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import { defaultPromiseResolve, moveArrayItem } from "../../../utils/objects-util";

import IconButton from "../IconButton";

const SectionItemListItems = ({
  t,
  column, value,
  onPropChange
}) => {
  const [dragIndex, setDragIndex] = useState(null);
  const [dragItem, setDragItem] = useState(null);

  const handleOnChangeItem = itemValue => {
    if(column.isReadonly){
      return;
    }

    onPropChange({
      [column.accessor]: value.map(listItem => listItem[column.itemValue.key] === itemValue[column.itemValue.key]
            ? { ...listItem, ...itemValue }
            : listItem
      )
    });
  };

  const handleOnDeleteItem = id => {    
    if(column.isReadonly){
      return;
    }

    onPropChange({ [column.accessor]: value.filter(listItem => listItem[column.itemValue.key] !== id) });
  };

  const handleOnDragEnter = index => {
    if(column.isDraggable) {
      setDragIndex(index);
    }
  }

  const handleOnDragStart = (e, item) => {
      if(column.isDraggable) {
          e.target.style.opacity = "0.4";
          setDragItem(item);
      }
  }

  const handleOnDragEnd = e => {
      if(column.isDraggable) {
          e.target.style.opacity = "1";
      }
  }

  const handleOnDrop = item => {
      if(column.isDraggable) {
        onPropChange({
          [column.accessor]: moveArrayItem(value.map((m, index)=> ({ ...m, order: index })), dragItem, item, "order", column.itemValue.key)
            ?.sort((a, b)=> a.order - b.order)
        });
        setDragItem(null);
        setDragIndex(null); 
      }
  }

  const handleOnDragOver = useCallback((e) => {
      e.preventDefault();
  }, []);

  useEffect(() => {
    if (window) {
        window.addEventListener("dragover", handleOnDragOver);
    }

    return () => {
        window.removeEventListener("dragover", handleOnDragOver);
    }
}, [handleOnDragOver]);

  return (
    <div className={classNames("sectionItemListItems")}>      
      {value && value.map((val, index) => (
          <div id={`sectionItemListItem-${val[column.itemValue.key]}`}
            key={`sectionItemListItem-${val[column.itemValue.key]}`}
            draggable={column.isDraggable}
            className={classNames("sectionItemListItem", { dropable: index === dragIndex })}
            onDragEnter={()=> handleOnDragEnter(index)}
            onDragStart={e=> handleOnDragStart(e, val)}
            onDragEnd={handleOnDragEnd}
            onDrop={()=> handleOnDrop(val)}
          >            
            {column.itemValue.component 
              ? (column.itemValue.component(val, handleOnChangeItem, handleOnDeleteItem)) 
              : (
              <div className={classNames("inputItemBlock")}>
                {column.isDraggable && (
                  <div className={classNames("moveItem")}>
                    <IconButton isIcon={true} iconName={"move"} tooltipText={t("basic.MOVE_ITEM_LABEL")}
                      onClick={defaultPromiseResolve} 
                    />
                  </div>
                )}
                <input type="text" readOnly={column.isReadonly || column.itemValue.isReadonly} value={column.itemValue.value ? column.itemValue.value(val) : val[column.itemValue.accessor]}
                  onChange={e => handleOnChangeItem({ ...val, [column.itemValue.accessor]: e.currentTarget.value })}
                />
                <div className={classNames("delete")} onClick={() => handleOnDeleteItem(val[column.itemValue.key])} />
              </div>
            )}
          </div>
        ))}
    </div>
  );
}

export default withTranslation()(SectionItemListItems);
